/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Cliche_Col_SeverityInputs */

const en_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const de_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const fr_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const es_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const it_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const nl_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const pl_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const fi_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const da_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const sv_keyword_optimizer_cliche_col_severity = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SeverityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

/**
* | output |
* | --- |
* | "Severity" |
*
* @param {Keyword_Optimizer_Cliche_Col_SeverityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_cliche_col_severity = /** @type {((inputs?: Keyword_Optimizer_Cliche_Col_SeverityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Cliche_Col_SeverityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "fr") return fr_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "es") return es_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "it") return it_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "nl") return nl_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "pl") return pl_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "fi") return fi_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "da") return da_keyword_optimizer_cliche_col_severity(inputs)
	if (locale === "sv") return sv_keyword_optimizer_cliche_col_severity(inputs)
	return en_keyword_optimizer_cliche_col_severity(inputs)
});